import types from './types';
import {makeCreator} from '~/misc/dispatch';
import {loadsSearchAction} from '~/modules/loadsSearch/actions';
import {query2recent} from './utils';

const recentSearches = makeCreator(types.RECENTSEARCHES_UPDATE, query2recent);

const requestRecent = (num) => (dispatch, getState) => {
  const state = getState();
  const items = state.recentSearches.items;
  const query = items && items[num];

  return dispatch(loadsSearchAction({
    ...query,
    from_name: query.from_name || '',
    to_name: query.to_name || '',
    date: [],
    isNotCompare: true
  }));
};

export {
  recentSearches,
  requestRecent,
};



// WEBPACK FOOTER //
// ./src/modules/recentSearches/actions.js